// "The Signal" — geiger-counter-style audio + haptic pulse used by
// GpsHintButton when an admin has opted a drop or loot-quest into the feature.
//
// signal_level (1..4) returned by the backend maps to ticking speed:
//   1 = ~1 click / sec   (just inside hot zone)
//   2 = ~2 clicks / sec
//   3 = ~4 clicks / sec
//   4 = ~8 clicks / sec  (dead-on)
//
// Total burst duration ≈ 3 seconds. Stops itself; non-blocking.

const TICKS_PER_SEC = { 1: 1, 2: 2, 3: 4, 4: 8 };
const BURST_MS = 3000;

let _ctx = null;
function ctx() {
  if (!_ctx) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    _ctx = new Ctx();
  }
  return _ctx;
}

function click(level) {
  const c = ctx();
  if (!c) return;
  const now = c.currentTime;
  const osc = c.createOscillator();
  const gain = c.createGain();
  // Higher pitch + sharper envelope when closer.
  const freq = 1200 + level * 400;
  osc.type = "square";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, now);
  gain.gain.linearRampToValueAtTime(0.18, now + 0.002);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.06);
  osc.connect(gain).connect(c.destination);
  osc.start(now);
  osc.stop(now + 0.07);
}

export function playSignalBurst(level) {
  const lvl = Math.max(1, Math.min(4, Number(level) || 1));
  const rate = TICKS_PER_SEC[lvl];
  const intervalMs = 1000 / rate;
  const total = Math.max(1, Math.round(BURST_MS / intervalMs));
  const c = ctx();
  if (c && c.state === "suspended") {
    try { c.resume(); } catch { /* noop */ }
  }
  // Schedule clicks
  for (let i = 0; i < total; i++) {
    setTimeout(() => click(lvl), i * intervalMs);
  }
  // Haptic pulse pattern (Android only — iOS Safari ignores). Vibrate
  // on/off pairs scaled to the same cadence.
  if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
    const pattern = [];
    const onMs = Math.min(60, intervalMs * 0.4);
    const offMs = Math.max(20, intervalMs - onMs);
    for (let i = 0; i < total; i++) {
      pattern.push(Math.round(onMs), Math.round(offMs));
    }
    try { navigator.vibrate(pattern); } catch { /* noop */ }
  }
}
